// This is a browser-only illustration. It reads sample text already in the HTML
// and never records audio, sends session content or calls the desktop backend.
const workspace = document.querySelector('[data-psy-workspace]');
if (workspace) {
    const scroll = workspace.querySelector('[data-psy-scroll]');
    // Keep the desktop illustration quiet at rest, without shifting its layout.
    for (const region of [scroll, workspace.closest('.psy-preview__viewport')]) {
        let hideScrollbar;
        region.addEventListener('scroll', () => {
            region.classList.add('is-scrolling');
            clearTimeout(hideScrollbar);
            hideScrollbar = setTimeout(() => region.classList.remove('is-scrolling'), 850);
        }, { passive: true });
    }
    const tabs = [...workspace.querySelectorAll('[data-psy-tab]')];
    const views = [...document.querySelectorAll('[data-psy-view]')];
    const panels = new Map(tabs.map(tab => [tab.dataset.psyTab, document.getElementById(tab.getAttribute('aria-controls'))]));
    function selectView(view) {
        workspace.dataset.view = view;
        const panelName = view === 'timeline' ? 'mood' : view === 'treatment' ? 'summary' : view;
        for (const tab of tabs) {
            const selected = tab.dataset.psyTab === panelName;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            panels.get(tab.dataset.psyTab).hidden = !selected;
        }
        views.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.psyView === view)));
        workspace.querySelector('[data-psy-mood-label]').textContent = panelName === 'transcript' ? 'Generate analysis' : 'Emotional insights';
        tabs.forEach(tab => { tab.querySelector('.pn-complete').hidden = tab.dataset.psyTab !== 'transcript' && !(tab.dataset.psyTab === 'mood' && panelName !== 'transcript'); });
        workspace.querySelector('[data-psy-generating]').hidden = view === 'treatment';
        const target = view === 'timeline' ? workspace.querySelector('[data-psy-timeline]') : view === 'treatment' ? workspace.querySelector('[data-psy-treatment]') : null;
        scroll.scrollTop = target ? target.getBoundingClientRect().top - scroll.getBoundingClientRect().top + scroll.scrollTop - 16 : 0;
    }
    views.forEach(button => button.addEventListener('click', () => selectView(button.dataset.psyView)));
    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectView(tab.dataset.psyTab));
        tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            selectView(tabs[next].dataset.psyTab);
            tabs[next].focus();
        });
    });
    const search = workspace.querySelector('[data-psy-search]');
    const lines = [...workspace.querySelectorAll('[data-psy-conversation] article')];
    const filters = [...workspace.querySelectorAll('[data-psy-filter]')];
    let speaker = 'all';
    function filterTranscript() {
        const query = search.value.trim().toLocaleLowerCase('en');
        lines.forEach(line => { line.hidden = (speaker !== 'all' && line.dataset.speaker !== speaker) || !line.textContent.toLocaleLowerCase('en').includes(query); });
        workspace.querySelector('[data-psy-empty]').hidden = lines.some(line => !line.hidden);
    }
    search.addEventListener('input', filterTranscript);
    filters.forEach(button => button.addEventListener('click', () => {
        speaker = button.dataset.psyFilter;
        filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
        filterTranscript();
    }));
    const speakers = workspace.querySelector('[data-psy-speakers]');
    const speakerPanel = workspace.querySelector('#pn-speaker-filters');
    speakers.addEventListener('click', () => {
        speakerPanel.hidden = !speakerPanel.hidden;
        speakers.setAttribute('aria-expanded', String(!speakerPanel.hidden));
    });
    const layouts = [...workspace.querySelectorAll('[data-psy-layout]')];
    layouts.forEach(button => button.addEventListener('click', () => {
        workspace.querySelector('[data-psy-conversation]').classList.toggle('is-list', button.dataset.psyLayout === 'list');
        layouts.forEach(layout => layout.setAttribute('aria-pressed', String(layout === button)));
    }));
    workspace.querySelector('[data-psy-copy]').addEventListener('click', async () => {
        const text = lines.filter(line => !line.hidden).map(line => `${line.querySelector('.pn-speaker').textContent}: ${line.querySelector('p').textContent}`).join('\n\n');
        const feedback = workspace.querySelector('[data-psy-feedback]');
        try {
            await navigator.clipboard.writeText(text);
            feedback.textContent = 'Sample transcript copied.';
        } catch {
            feedback.textContent = 'Copy is unavailable in this browser. You can select and copy the sample text.';
        }
    });
}

// The roadmap is readable in full without scripts. Enhance it with the same
// tab pattern as the homepage deployment explorer once JavaScript is available.
const planTabs = document.querySelector('[data-psy-plan-tabs]');
if (planTabs) {
    const tabs = [...planTabs.querySelectorAll('[role="tab"]')];
    const panels = [...document.querySelectorAll('[data-psy-plan-panel]')];
    const selectPlan = (tab, focus = false) => {
        for (const item of tabs) {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
        }
        panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
        if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectPlan(tab));
        tab.addEventListener('keydown', event => {
            const rtl = getComputedStyle(planTabs).direction === 'rtl';
            let next;
            if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + tabs.length) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + tabs.length) % tabs.length;
            if (next === undefined) return;
            event.preventDefault();
            selectPlan(tabs[next], true);
        });
    });
    selectPlan(tabs[0]);
}
